import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCCContext } from '../CC/CCContext';
import styles from './BiblioCount.module.css';

interface SearchResultComponentProps {

}

const BiblioCount: React.FC<SearchResultComponentProps> = ({ }) => {
    const { t } = useTranslation();
    const { cc } = useCCContext();
    const [count, setCount] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [serverUrl, setServerUrl] = useState<string | null>(null);  // Step 2: Add this line

    function getFirstSearchValue(obj: any) {
        // Loop through the searches
        for (const search of obj.Searches) {
            if (search.searchValues && search.searchValues.length > 0) {
                // Return the first text value encountered
                return search.searchValues[0].text;
            }
        }

        // If we've reached this point, all searches are empty
        // Iterate over all facets
        for (const key in obj.facets) {
            if (obj.facets[key].length > 0) {
                return obj.facets[key][0];
            }
        }

        // If no facet value found, iterate over all hierarchicalFacets
        for (const key in obj.hierarchicalFacets) {
            if (obj.hierarchicalFacets[key].length > 0) {
                // Check if it's an object (e.g. with 'term' key)
                if (typeof obj.hierarchicalFacets[key][0] === 'object' && obj.hierarchicalFacets[key][0].term) {
                    return obj.hierarchicalFacets[key][0].term;
                } else {
                    // If it's a simple string or another primitive type
                    return obj.hierarchicalFacets[key][0];
                }
            }
        }

        // Return null if no value is found
        return null;
    }

    useEffect(() => {
        console.log(JSON.stringify(cc));
        async function fetchData() {
            try {
                let query = getFirstSearchValue(cc);
                const url = `${process.env.REACT_APP_BIBLIO_URL}?query=${query}`;  // Changed this variable name
                console.log(url);
                // setServerUrl(`http://vm-primo.quaibranly.fr:8991/primo_library/libweb/action/search.do?vid=mqb_internet&tab=default_tab&mode=Basic&fn=search&ct=search&vl(freeText0)=${query}`);
                setServerUrl(`https://mqb-primo.hosted.exlibrisgroup.com/primo-explore/search?tab=default_tab&search_scope=default_scope&vid=MQB&lang=fr_FR&ct=search&query=any,contains,${query}`);
                const response = await fetch(url);
                const text = await response.text();
                setCount(text);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        }
        if (getFirstSearchValue(cc)) {
            fetchData();
        } else {
            setCount(null);
        }
    }, [cc]);

    if (isLoading) {
        return <div />;
    }

    const numericCount = parseInt(count || "0", 10);

    return (
        <div className={styles.BiblioCount}>
            {serverUrl && !isNaN(numericCount) && numericCount > 0 && (
                // Step 3: Update the render
                <div className={styles.text}>
                    <a className={styles.hyperlink} href={serverUrl} target="_blank" rel="noopener noreferrer">
                        {count}
                    </a>
                    <span>
                    &nbsp;{t("biblio_results")} 
                    </span>
                </div>
            )}
        </div>
    );

}

export default BiblioCount;
